const RetentionHistoryAction = Object.freeze({
  audit_log_clean_up: 'TaskHistoryList_AuditLogCleanUp',
  campaign_audit_log_clean_up: 'TaskHistoryList_CampaignAuditLogCleanUp',
  cleanup_users: 'TaskHistoryList_CleanupUsers',
  audit_log_clean_up_preview: 'TaskHistoryList_AuditLogCleanUpPreview',
  campaign_audit_log_clean_up_preview:
    'TaskHistoryList_CampaignAuditLogCleanUpPreview',
  cleanup_users_preview: 'TaskHistoryList_CleanupUsersPreview'
})

const RetentionHistoryRunType = Object.freeze({
  live: 'RetentionHistory_Live',
  preview: 'RetentionHistory_Preview'
})

export { RetentionHistoryAction, RetentionHistoryRunType }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/RetentionHistoryType.js